import { getHighlitedDates } from "./getHighlitedDates";

export const getIsSelectedDateInProductionTime = (
  date: Date | undefined,
  productionTime: number | undefined
) => {
  if (!date) {
    return false;
  }

  const selectedDate = new Date(date).toDateString();
  const productionDates = getHighlitedDates(productionTime).map((date) =>
    date.toDateString()
  );

  return productionDates.includes(selectedDate);
};
